import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { Field } from 'formik'


const InputHeader = styled.h3`
    @media (max-width: ${props => props.theme.responsive.small}) {
        font-size: 16px;
    }
    margin-bottom: 0.5em;
    font-weight: bold;
`

const Checkmark = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid ${props => props.theme.colors.base};
    border-radius: 25px;

    &:after {
        content: "";
        position: absolute;
        display: none;
        top: 3px;
        left: 3px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: white;
        background-color: ${props => props.theme.colors.darkGreen};
   }
`

const RadioButton = styled(Field)`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ ${Checkmark}:after {
        display: block;
    }

    &:checked ~ ${Checkmark} {
        border-color: ${props => props.theme.colors.darkGreen};
    }
`

const SelectionLabel = styled.label`
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-radius: 25px;
`

const SelectionDescription = styled.div`
    flex: 100%;
    padding-bottom: 1em;
`

const SelectionWrapper = styled.div`
    flex: 100%;
    position:relative;
`

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 3em;
`

class RadioButtonGroup extends React.Component {

    render() {
        const { data } = this.props
        const { header, selections, description, required } = data

        return (
            <Wrapper>
                <InputHeader>
                    {header} {required && required === true && '*'}
                </InputHeader>

                {description &&
                    <SelectionDescription>
                        <ReactMarkdown
                            source={description.description || ''}
                            escapeHtml={false}
                            renderers={{link: props => <a href={props.href} rel="noopener noreferrer" target="_blank">{props.children}</a>}}
                        />
                    </SelectionDescription>
                }

                {selections.map(( item, index ) =>
                    <SelectionWrapper key={index}>
                        <SelectionLabel>
                            {item.header}
                            <RadioButton
                                id={item.id}
                                name={data.integrationObjectName}
                                type="radio"
                                value={item.mappingId}
                            />
                            <Checkmark>
                            </Checkmark>
                        </SelectionLabel>
                    </SelectionWrapper>
                )}
            </Wrapper>
        )
    }
}

RadioButtonGroup.propTypes = {
    data: PropTypes.object
}

export default RadioButtonGroup
